/**
 * Error handling mixin
 */

export default {
  methods: {
    /**
     * Handle and report an error
     * @param {string} message - User-friendly error message
     * @param {Error} error - The error object
     * @param {Object} [options] - Additional options
     * @param {string} [options.type='error'] - The type of notification ('error', 'warning', 'info')
     * @param {number} [options.timeout=3000] - How long to show the notification
     */
    handleError(message, error, options = {}) {
      const { type = 'error', timeout = 3000 } = options;

      // Log the error for debugging
      console.error(message, error);

      // Emit the error event for parent components
      this.$emit('error', { message, error });

      // Show notification if snackbar is available
      if (this.$root.snackBar?.show) {
        this.$root.snackBar.show({
          appear: true,
          color: type,
          text: `${message}: ${error.message}`,
          timeout,
        });
      }
    },
  },
};
